import { c as _c } from "react/compiler-runtime";
import { cx } from '@7f-ui';
import type { BreadcrumbItem } from '@7f-ui/components/breadcrumb/breadcrumb';
import { Breadcrumb } from '@7f-ui/components/breadcrumb/breadcrumb';
import { dateParser } from '@feat/feat-url-state/date';
import { paxParser } from '@feat/feat-url-state/pax';
import { serializeUrlState } from '@feat/feat-url-state/schema';
import { useUrlState } from '@feat/feat-url-state/use-url-state';
import { objectKeys } from '@utils/helpers';
import { pick } from 'es-toolkit';
import { useState } from 'react';
import type { AccommodationFragment } from 'src/lib/backend/documents/accommodation';
import { getAccommodationPath } from 'src/lib/urls/accommodation';
type AccommodationBreadcrumbsProps = {
  accommodation: AccommodationFragment;
  destination?: {
    slug: string;
    name: string;
  } | null;
  links?: BreadcrumbItem[];
  placement: 'top' | 'bottom';
};
export function AccommodationBreadcrumbs(t0) {
  const $ = _c(30);
  const {
    links: t1,
    destination,
    accommodation,
    placement
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const links = t2;
  const {
    urlState
  } = useUrlState();
  let t3;
  if ($[2] !== urlState) {
    t3 = serializeUrlState(pick(urlState, objectKeys({
      ...dateParser,
      ...paxParser
    })));
    $[2] = urlState;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const searchParams = t3;
  const [selection] = useState(searchParams);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      url: "/reiseziele/",
      label: "Alle Reiseziele"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let breadcrumbs;
  if ($[5] !== accommodation.id || $[6] !== accommodation.name || $[7] !== accommodation.slug || $[8] !== destination || $[9] !== links || $[10] !== selection) {
    breadcrumbs = [t4];
    if (destination) {
      const t5 = `/reiseziele/${destination.slug}/`;
      let t6;
      if ($[12] !== destination.name || $[13] !== t5) {
        t6 = {
          label: destination.name,
          url: t5
        };
        $[12] = destination.name;
        $[13] = t5;
        $[14] = t6;
      } else {
        t6 = $[14];
      }
      breadcrumbs.push(t6);
    }
    const t5 = `${getAccommodationPath(accommodation.id, accommodation.slug)}${selection}`;
    let t6;
    if ($[15] !== accommodation.name || $[16] !== t5) {
      t6 = {
        label: accommodation.name,
        url: t5,
        truncate: true
      };
      $[15] = accommodation.name;
      $[16] = t5;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    breadcrumbs.push(t6);
    breadcrumbs.push(...links);
    $[5] = accommodation.id;
    $[6] = accommodation.name;
    $[7] = accommodation.slug;
    $[8] = destination;
    $[9] = links;
    $[10] = selection;
    $[11] = breadcrumbs;
  } else {
    breadcrumbs = $[11];
  }
  const t5 = placement === "bottom";
  let t6;
  if ($[18] !== t5) {
    t6 = cx({
      "fluid-grid fluid-container": t5
    });
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const t7 = placement === "bottom";
  let t8;
  if ($[20] !== t7) {
    t8 = cx({
      "col-span-12 sm:col-span-7": t7
    });
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const t9 = placement === "top";
  let t10;
  if ($[22] !== breadcrumbs || $[23] !== placement || $[24] !== t8 || $[25] !== t9) {
    t10 = <Breadcrumb className={t8} placement={placement} useFluidContainer={t9} links={breadcrumbs} />;
    $[22] = breadcrumbs;
    $[23] = placement;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t6) {
    t11 = <div className={t6}>{t10}</div>;
    $[27] = t10;
    $[28] = t6;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}